<template>
  <v-radio-group
    v-model="planId"
    class="ma-0"
    hide-details
  >
    <div
      v-if="hasStarterOptions"
      class="options-block mt-4"
    >
      <h3 class="mb-2 clr-starter">
        <v-icon>mdi-diamond-stone</v-icon>
        Starter
      </h3>
      <PaymentSelectionBox
        v-for="item in tierPlans.starter"
        :id="item.id"
        :key="item.id"
        class="mb-2 payment-box_full-width"
        :class="{ 'no-events': currentTierPlanId === item.id }"
        :title="item.title"
        :price="item.month_price"
        :subtitle="item.subtitle"
        :compact="true"
        :tagText="currentTierPlanId === item.id ? $t(`tags.queued_plan`) : ''"
        :selected="planId === item.id"
        :selectedGrey="currentTierPlanId === item.id"
        :tagGrey="currentTierPlanId === item.id"
        @click="onPlanSelected(item)"
      >
        <v-radio
          :key="item.id"
          :color="currentTierPlanId === item.id ? '#616161' : 'primary'"
          :value="currentTierPlanId === item.id ? planId : item.id"
        ></v-radio>
      </PaymentSelectionBox>
    </div>

    <div class="d-flex mt-4">
      <h3 class="clr-premium">
        <v-icon>mdi-diamond-stone</v-icon>
        Premium
      </h3>
    </div>

    <div class="options-block mt-2">
      <PaymentSelectionBox
        v-for="item in tierPlans.premium"
        :id="item.id"
        :key="item.id"
        class="mb-2 payment-box_full-width"
        :class="{ 'no-events': currentTierPlanId === item.id }"
        :title="item.title"
        :price="item.month_price"
        :subtitle="item.subtitle"
        :priceNoDiscount="item.no_discount_month_price"
        :compact="true"
        :tagText="currentTierPlanId === item.id ? $t(`tags.queued_plan`) : ''"
        :selected="planId === item.id"
        :selectedGrey="currentTierPlanId === item.id"
        :tagGrey="currentTierPlanId === item.id"
        @click="onPlanSelected(item)"
      >
        <v-radio
          :key="item.id"
          :color="currentTierPlanId === item.id ? '#616161' : 'primary'"
          :value="currentTierPlanId === item.id ? planId : item.id"
        ></v-radio>
      </PaymentSelectionBox>
    </div>

    <div class="d-flex mt-4">
      <h3 class="clr-elite">
        <v-icon>mdi-diamond-stone</v-icon>
        Elite
      </h3>
      <router-link
        v-if="subscriptionTier !== 'ELITE'"
        data-tst="update_plan_flow_2"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gmType },
        }"
        class="ml-2 my-auto text-small link-underline link-underline_compact text-grey"
      >
        {{ $t(`sub_update.see_premium_features`) }}
      </router-link>
    </div>
    <div class="text-small weight_500 mt-1 clr-yellow">
      <!-- {{ $t('subscription.early_bird_price', { discount: 16 }) }} -->
    </div>

    <div class="options-block mt-2">
      <PaymentSelectionBox
        v-for="item in tierPlans.elite"
        :id="item.id"
        :key="item.id"
        class="mb-2 payment-box_full-width"
        :class="{ 'no-events': currentTierPlanId === item.id }"
        :title="item.title"
        :price="item.month_price"
        :subtitle="item.subtitle"
        :priceNoDiscount="item.no_discount_month_price"
        :compact="true"
        :tagText="
          currentTierPlanId === item.id
            ? $t(`tags.queued_plan`)
            : item.bestValue
              ? $t(`tags.best_value`) +
                `${
                  item.savings
                    ? ` - ${$t(`tags.save_up_to`, {
                        amount: item.savings,
                      })}`
                    : ''
                }`
              : ''
        "
        :selected="planId === item.id"
        :selectedGrey="currentTierPlanId === item.id"
        :tagGrey="currentTierPlanId === item.id"
        @click="onPlanSelected(item)"
      >
        <v-radio
          :key="item.id"
          :color="currentTierPlanId === item.id ? '#616161' : 'primary'"
          :value="currentTierPlanId === item.id ? planId : item.id"
        ></v-radio>
      </PaymentSelectionBox>
    </div>
  </v-radio-group>
</template>

<script>
import PaymentSelectionBox from '@/components/Payments/PaymentSelectionBox.vue'

export default {
  name: 'SubscriptionPlanSelector',
  components: {
    PaymentSelectionBox,
  },
  props: {
    value: {
      type: String,
      default: 'none',
    },
    currentTierPlanId: {
      type: String,
      required: true,
    },
    hasStarterOptions: {
      type: Boolean,
      default: false,
    },
    allTierPlans: {
      type: Object,
      required: true,
    },
    subscriptionTier: {
      type: String,
      default: '',
    },
    gmType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      planId: this.value,
    }
  },
  methods: {
    onPlanSelected(plan) {
      if (this.currentTierPlanId !== plan.id) {
        this.planId = plan.id
        this.$emit('plan-selected', plan)
      }
    },
  },
  computed: {
    tierPlans() {
      return this.allTierPlans
    },
  },
  watch: {
    value(newVal) {
      this.planId = newVal
    },
    planId(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>
